<template>
  <div v-show="visible" class="kq-theme-tab-dropdown-container" :style="style">
    <div
      class="kq-theme-tab-dropdown"
      v-for="item in list"
      :key="item.command"
      :data-value="item.command"
      @click="$emit('close', item.command)"
    >
      <kq-icon :name="item.icon" />
      <div class="kq-theme-tab-dropdown-title">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabDropdown',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  computed: {
    style() {
      return {
        left: this.x + 'px',
        top: this.y + 'px',
        display: this.visible ? 'block' : 'none '
      }
    }
  },
  mounted() {
    document.querySelector('body').appendChild(this.$el)
  },
  watch: {
    visible(val) {
      if (val) {
        window.addEventListener('mousedown', this.contextmenu)
      } else {
        window.removeEventListener('mousedown', this.contextmenu)
      }
    }
  },
  methods: {
    contextmenu(event) {
      if (!this.$el.contains(event.target) || event.button !== 0) {
        this.$emit('update:visible', false)
      }
    }
  }
}
</script>
